import { useEffect, useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import PostCard from '../components/ui/PostCard';
import EmojiPicker from '../components/ui/EmojiPicker';

export default function ActusMembres() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('global');
  const [posts, setPosts] = useState([]);
  const [text, setText] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const fileRef = useRef();
  const token = localStorage.getItem('mjtoken');

  useEffect(() => {
    if (!user) { navigate('/connexion'); return; }
    fetchPosts();
  }, [user, activeTab]);

  const fetchPosts = async () => {
    const url = activeTab === 'global' ? '/api/posts/global' : '/api/posts/friends';
    const res = await fetch(url, { headers: { Authorization: 'Bearer ' + token } });
    const data = await res.json();
    if (Array.isArray(data)) setPosts(data);
  };

  const handleSubmit = async () => {
    if (!text.trim() && !file) return;
    setLoading(true);
    const fd = new FormData();
    if (text) fd.append('text', text);
    if (file) fd.append('image', file);
    const res = await fetch('/api/posts', {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + token },
      body: fd
    });
    if (res.ok) {
      const newPost = await res.json();
      setPosts(prev => [newPost, ...prev]);
      setText('');
      setFile(null);
      if (fileRef.current) fileRef.current.value = '';
    }
    setLoading(false);
  };

  const handleUpdate = (updated) => {
    setPosts(prev => prev.map(p => p._id === updated._id ? updated : p));
  };

  const handleDelete = (id) => {
    setPosts(prev => prev.filter(p => p._id !== id));
  };

  const initiales = (user?.username || 'U').slice(0,2).toUpperCase();

  return (
    <div style={{ background: '#fafaf8', minHeight: '100vh', fontFamily: 'Arial,sans-serif' }}>
      <div style={{ maxWidth: 680, margin: '0 auto', padding: '2rem 1.5rem' }}>
        <div style={{ fontSize: 12, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#8b1a2a', marginBottom: 6, fontWeight: 500 }}>Communaute</div>
        <h1 style={{ fontFamily: 'Georgia,serif', fontSize: '1.8rem', fontWeight: 400, color: '#1a1a1a', marginBottom: '1.5rem', lineHeight: 1.2 }}>
          Actu membres, <em style={{ color: '#8b1a2a', fontStyle: 'italic' }}>le fil de la communaute</em>
        </h1>

        <div style={{ display: 'flex', gap: 8, marginBottom: '1.5rem' }}>
          {[{ key: 'global', label: 'Fil global' }, { key: 'friends', label: 'Mes amis' }].map(t => (
            <button key={t.key} onClick={() => setActiveTab(t.key)}
              style={{ padding: '6px 18px', borderRadius: 20, border: '1px solid #c49090', fontSize: 13, cursor: 'pointer', color: activeTab === t.key ? '#fff' : '#8b1a2a', background: activeTab === t.key ? '#8b1a2a' : '#fafaf8' }}>
              {t.label}
            </button>
          ))}
        </div>

        <div style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 10, padding: 16, marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', marginBottom: 12 }}>
            <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#e8c0c8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#8b1a2a', overflow: 'hidden', flexShrink: 0 }}>
              {user?.photo ? <img src={user.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initiales}
            </div>
            <textarea value={text} onChange={e => setText(e.target.value)} rows={2}
              onInput={e => { e.target.style.height = 'auto'; e.target.style.height = e.target.scrollHeight + 'px'; }}
              placeholder="Partagez une pensee, un souvenir, une decouverte sur Michael..."
              style={{ flex: 1, padding: '10px 12px', border: '1px solid #c49090', borderRadius: 8, fontSize: 13, color: '#1a1010', background: '#fafaf8', resize: 'vertical', fontFamily: 'Arial,sans-serif', boxSizing: 'border-box', minHeight: 60, overflow: 'hidden' }} />
          </div>
          {file && <div style={{ fontSize: 12, color: '#8b1a2a', marginBottom: 8 }}>Photo: {file.name}</div>}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <button onClick={() => fileRef.current?.click()} style={{ fontSize: 12, color: '#8b1a2a', cursor: 'pointer', background: 'none', border: 'none', display: 'flex', alignItems: 'center', gap: 5 }}>
                📷 Ajouter une photo
              </button>
              <EmojiPicker onEmojiClick={emoji => setText(prev => prev + emoji)} />
            </div>
            <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => setFile(e.target.files[0])} />
            <button onClick={handleSubmit} disabled={loading || (!text.trim() && !file)}
              style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: loading || (!text.trim() && !file) ? '#c49090' : '#8b1a2a', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              {loading ? 'Publication...' : 'Publier'}
            </button>
          </div>
        </div>

        {posts.length === 0 && (
          <div style={{ textAlign: 'center', padding: '40px 0', color: '#9a8080', fontSize: 13, fontStyle: 'italic' }}>
            {activeTab === 'friends' ? 'Aucune actu de vos amis pour l\'instant.' : 'Soyez le premier a publier une actu !'}
          </div>
        )}

        {posts.map(post => (
          <PostCard key={post._id} post={post} currentUserId={user?._id || user?.id}
            token={token} onUpdate={handleUpdate} onDelete={handleDelete} />
        ))}
      </div>
    </div>
  );
}
